import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgFire(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="6 -4 12 24" {...props}>
      <path
        d="M17.676 7.69a9.445 9.445 0 00-.52-1.374c-.146-.308-.883-1.437-1.03-1.676.383 2.471-.575 3.432-.795 3.635.03-.238.053-.473.07-.701.146-2.037-.303-4.002-1.613-5.499a5.822 5.822 0 00-2.56-1.704c-.83-.27-1.817-.484-2.68-.305.689.375 1.173.87 1.557 1.549.398.703.581 1.542.446 2.462-.112.757-.48 1.65-1.075 2.114a9.048 9.048 0 01-.237-.504c-.272-.632-.474-1.352-.401-2.061.023-.23.073-.463.158-.69 0 0-1.655 1.409-2.356 3.054-.45 1.053-.62 1.871-.639 3.035-.013.84.087 1.68.301 2.485.946 3.54 4.45 5.146 7.51 4.243 1.172-.347 2.232-1.138 2.981-2.201.839-1.19 1.316-2.754 1.186-4.27a8.224 8.224 0 00-.303-1.592z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Fire')(SvgFire);
